import Request from '../../common/copyright/request';

export const sendMsg = (data) => Request.post('/promote/api/auth/sendMsg', data);
export const login = (data) => Request.post('/promote/api/plusPromoteUser/login', data,{network401 :'custom401'});
export const signProtocol = (data,access_token) => Request.put('/promote/api/auth/signProtocol', data, { 'Authorization':'Bearer '+access_token});
export const validate = (data) => Request.post('/promote/api/plusPromoteUser/validate', data);
